import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ['listItem', 'buttonDiv'];

    initialize() {
        this.highestGroupingOpened = 1;
    }

    show() {
        this.highestGroupingOpened++;

        if (this.listItemTargets) {
            this.listItemTargets.forEach((element, index) => {
                if (element.classList.contains('hidden')) {
                    if (this.highestGroupingOpened == element.dataset.newsMultiGroup) {
                        element.classList.remove('hidden');
                    }
                }
            });
    
            var foundHidden = false;
    
            this.listItemTargets.forEach((element, index) => {
                if (element.classList.contains('hidden')) {
                    foundHidden = true;
                }
            });
    
            if (!foundHidden && this.buttonDivTarget) {
                this.buttonDivTarget.remove();
            }
        }
    }
}
